import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { ArrowDownToLine, ArrowUpFromLine, Repeat } from 'lucide-react';
import type { FlowLayerPlacement } from '@/store/videoFeatures/types/conversion-journey';
import { cn } from '@/lib/utils';

interface Props {
  value: FlowLayerPlacement;
  onChange: (v: FlowLayerPlacement) => void;
}

const OPTIONS: Array<{
  id: FlowLayerPlacement;
  title: string;
  icon: React.ReactNode;
}> = [
  {
    id: 'before',
    get title() { return translateInterfaceText("Antes do principal"); },
    icon: <ArrowUpFromLine className="w-4 h-4" />,
  },
  {
    id: 'after',
    get title() { return translateInterfaceText("Depois do principal"); },
    icon: <ArrowDownToLine className="w-4 h-4" />,
  },
  {
    id: 'before_and_after',
    get title() { return translateInterfaceText("Antes e depois"); },
    icon: <Repeat className="w-4 h-4" />,
  },
];

export const FlowLayerPlacementSelector: React.FC<Props> = ({ value, onChange }) => {
  useLanguage();
  return (
    <section className="rounded-[16px] border border-[#E5E7EB] bg-white p-5 space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {OPTIONS.map((opt) => {
          const active = value === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => onChange(opt.id)}
              className={cn(
                'text-left flex flex-col gap-2 p-3.5 rounded-[12px] border transition-colors',
                active
                  ? 'border-[#4B7BFF] bg-[#EEF2FF]'
                  : 'border-[#E5E7EB] bg-white hover:bg-[#F9FAFB]',
              )}
            >
              <div className="flex items-center justify-between">
                <span
                  className={cn(
                    'w-8 h-8 rounded-[8px] flex items-center justify-center',
                    active ? 'bg-white text-[#4B7BFF]' : 'bg-[#F3F4F6] text-[#6B7280]',
                  )}
                >
                  {opt.icon}
                </span>
                <span
                  className={cn(
                    'w-4 h-4 rounded-full border flex items-center justify-center',
                    active ? 'border-[#4B7BFF]' : 'border-[#CBD5E1]',
                  )}
                >
                  {active && <span className="w-2 h-2 rounded-full bg-[#4B7BFF]" />}
                </span>
              </div>
              <div>
                <p className="text-[12px] leading-tight whitespace-nowrap font-normal text-[#1A1A1A]">
                  {opt.title}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default FlowLayerPlacementSelector;
